import React from 'react';

// material-ui
import { AppBar, Box, Button, ButtonBase, Divider, Grid, Toolbar, Typography } from '@mui/material';
import Badge, { BadgeProps } from '@mui/material/Badge';
import ExtranetLogo from '../../../components/nav/ExtranetLogo';
import { styled, useTheme } from '@mui/material/styles';
import { NotificationsNone } from '@mui/icons-material';

interface topBarProps {
    showWaivers: boolean;
    pendingWaiversCount: number;
    openWaiversList: () => void;
    closeWaiversList: () => void;
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -3,
        top: 6,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));


const TopBar = (props: topBarProps): JSX.Element => {

    const theme = useTheme();

    return (
        <Grid item xs={12}>
            {/* top navigation bar */}
            <AppBar
                position="relative"
                color="inherit"
                elevation={0}
                sx={{
                    bgcolor: '',
                    transition: 'none',
                }}
            >
                <Toolbar>
                    <Box
                        sx={{
                            width: 228,
                            display: 'flex',
                        }}
                    >
                        <Box component="span" sx={{ display: 'block', flexGrow: 1 }}>
                            <ButtonBase>
                                <ExtranetLogo></ExtranetLogo>
                            </ButtonBase>
                        </Box>
                    </Box>

                    <Box sx={{ flexGrow: 1 }} marginTop={3}>
                        <Typography variant="h6" sx={{ color: theme.palette.info.main}} fontWeight={550}>
                            Deposit Report Fine Tracker
                        </Typography>
                    </Box>
                    <Box sx={{ flexGrow: 2 }} marginTop={3}>
                        <Typography variant="h6">
                            Today: {new Date().toLocaleDateString()}
                        </Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1 }} marginTop={3}>
                        <Button variant="text" href="/FineTracker/Guide" target="_blank" rel="noopener">Application Manual</Button>
                    </Box>
                    {
                        props.showWaivers ?
                            <Box sx={{ flexGrow: 1 }} marginTop={3}>
                                <Button variant="outlined" onClick={props.closeWaiversList}>Return to Fine List</Button>
                            </Box>
                            :
                            <Box sx={{ flexGrow: 1 }} marginTop={3}>
                                <Button onClick={props.openWaiversList} variant="text" startIcon=
                                    {
                                        <StyledBadge badgeContent={props.pendingWaiversCount} color="error" invisible={false}>
                                            <NotificationsNone color="action" />
                                        </StyledBadge>
                                    }>
                                    &nbsp; &nbsp; Pending Waivers
                                </Button>
                            </Box>
                    }
                </Toolbar>
            </AppBar>
        </Grid>
    );
};

export default TopBar